function page(path) {
  return () => import(/* webpackChunkName: '' */ `~/views/${path}`).then((m) => m.default || m);
}

export default [
  { path: '/', name: 'home', component: page('home.vue') },

  {
    path: '/login',
    name: 'login',
    component: page('auth/login.vue'),
    props: true,
  },
  { path: '/password/reset', name: 'password.request', component: page('auth/password/email.vue') },
  {
    path: '/password/reset/:token',
    name: 'password.reset',
    component: page('auth/password/reset.vue'),
  },
  {
    path: '/email/verify/:id',
    name: 'verification.verify',
    component: page('auth/verification/verify.vue'),
  },
  {
    path: '/email/resend',
    name: 'verification.resend',
    component: page('auth/verification/resend.vue'),
  },
  { path: '/home', name: 'home', component: page('home.vue') },
  {
    path: '/settings',
    component: page('settings/index.vue'),
    children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: page('settings/profile.vue') },
      { path: 'password', name: 'settings.password', component: page('settings/password.vue') },
      { path: 'profileEnterprise', name: 'settings.profileEnterprise', component: page('settings/profileEnterprise.vue') },
    ],
  },
  {
    path: '/planes-corporativos/cuentas',
    name: 'planes-corporativos.cuentas',
    component: page('corporate-plans/acounts/index.vue'),
  },
  {
    path: '/planes-corporativos/acounts/agregar',
    name: 'planes-corporativos.acounts.agregar',
    component: page('corporate-plans/acounts/create.vue'),
  },
  {
    path: '/planes-corporativos/cuentas/:historyId/historial',
    name: 'planes-corporativos.account.historial',
    component: page('corporate-plans/acounts/history.vue'),
    props: true,
  },
  {
    path: '/planes-corporativos/reportes-cuentas',
    name: 'planes-corporativos.reportes-cuentas',
    component: page('corporate-plans/logs/index.vue'),
  },
  {
    path: '/planes-corporativos/distribuidores-asociados',
    name: 'planes-corporativos.distribuidores-asociados',
    component: page('corporate-plans/acounts/dealer_associated.vue'),
  },
  {
    path: '/usuarios',
    name: 'users',
    component: page('users/index.vue'),
    props: true,
  },
  {
    path: '/usuarios/agregar',
    name: 'createUser',
    component: page('users/create.vue'),
    props: true,
  },
  {
    path: '/usuarios/:dealerId/:id/editar',
    name: 'editUser',
    component: page('users/create.vue'),
    props: true,
  },
  {
    path: '/reportes/transacciones',
    name: 'reportLicenses',
    component: page('reports/licences/index.vue'),
    props: true,
  },
  {
    path: '/alertas/reportes-certificados',
    name: 'reportsCertificates',
    component: page('reports/certificate/index.vue'),
    props: true,
  },
  {
    path: '/alertas/reportes-licencias',
    name: 'reportsLicenses',
    component: page('reports/licences/report.vue'),
    props: true,
  },
  {
    path: '/alertas/reportes-folios',
    name: 'reportsPages',
    component: page('reports/pages/index.vue'),
    props: true,
  },
  {
    path: '/catalogos/dispositivos',
    name: 'devices',
    component: page('catalogs/devices/index.vue'),
    props: true,
  },
  {
    path: '/catalogos/dispositivos/agregar',
    name: 'createDevices',
    component: page('catalogs/devices/create.vue'),
    props: true,
  },
  {
    path: '/catalogos/dispositivos/editar/:id',
    name: 'editDevices',
    component: page('catalogs/devices/create.vue'),
    props: true,
  },
  {
    path: '/catalogos/servicios',
    component: page('catalogs/services/index.vue'),
    props: true,
  },
  {
    path: '/catalogos/servicios/:id',
    component: page('catalogs/services/stock.vue'),
    props: true,
  },
  {
    path: '/empresas',
    component: page('enterprises/index.vue'),
    name: 'enterprises',
    props: true,
  },
  {
    path: '/empresas/agregar',
    component: page('enterprises/associate.vue'),
    props: true,
  },
  {
    path: '/empresas/importar',
    name: 'enterprises.import',
    component: page('enterprises/import.vue'),
    props: true,
  },
  {
    path: '/empresas/:id',
    component: page('enterprises/profile.vue'),
    props: true,
    children: [
      {
        path: '',
        redirect: {
          name: 'enterprise.profileEnterprise',
        },
      },
      {
        path: 'perfil',
        name: 'enterprise.profileEnterprise',
        component: page('enterprises/associate.vue'),
        props: true,
      },
      {
        path: 'licencias',
        name: 'enterprise.licences',
        component: page('enterprises/licences/index.vue'),
        props: true,
      },
      {
        path: 'licencias/:licenceId/ciclos',
        name: 'enterprise.licences.cycles',
        component: page('enterprises/licences/cycles.vue'),
        props: true,
      },
      {
        path: 'asociados',
        name: 'enterprise.partners',
        component: page('enterprises/partners/index.vue'),
        props: true,
      },
      {
        path: 'reporte-consumo',
        name: 'enterprise.consumption',
        component: page('enterprises/consumption/index.vue'),
        props: true,
      },
      {
        path: 'asociados/agregar',
        name: 'enterprise.partners.create',
        component: page('enterprises/partners/create.vue'),
        props: true,
      },
      {
        path: 'asociados/:idAsociados/editar',
        name: 'enterprise.partners.edit',
        component: page('enterprises/partners/create.vue'),
        props: true,
      },
      {
        path: 'sucursales',
        name: 'enterprise.subsidiaries',
        component: page('enterprises/subsidiary/index.vue'),
        props: true,
      },
      {
        path: 'sucursales/agregar',
        name: 'enterprise.subsidiaries.create',
        component: page('enterprises/subsidiary/create.vue'),
        props: true,
      },
      {
        path: 'sucursales/:idSucursal/editar',
        name: 'enterprise.subsidiaries.edit',
        component: page('enterprises/subsidiary/create.vue'),
        props: true,
      },
      {
        path: 'sucursales/:idSucursal/punto',
        name: 'enterprise.subsidiaries.point',
        component: page('enterprises/subsidiary/point.vue'),
        props: true,
      },
      {
        path: 'sucursales/:idSucursal/punto/:pointId/editar',
        name: 'enterprise.subsidiaries.point.edit',
        component: page('enterprises/subsidiary/createPoint.vue'),
        props: true,
      },
      {
        path: 'usuarios',
        name: 'enterprise.users',
        component: page('enterprises/users/index.vue'),
        props: true,
      },
      {
        path: 'usuarios/agregar',
        name: 'enterprise.users.create',
        component: page('enterprises/users/create.vue'),
        props: true,
      },
      {
        path: 'usuarios/:idUsuario/:type/editar',
        name: 'enterprise.users.edit',
        component: page('enterprises/users/create.vue'),
        props: true,
      },
      {
        path: 'integracion',
        name: 'enterprise.integration',
        component: page('enterprises/integration/index.vue'),
        props: true,
      },
      {
        path: 'integracion/agregar',
        name: 'enterprise.integracion.create',
        component: page('enterprises/integration/create.vue'),
        props: true,
      },
      {
        path: 'integracion/:idIntegration/editar',
        name: 'enterprise.integracion.edit',
        component: page('enterprises/integration/create.vue'),
        props: true,
      },
      {
        path: 'documentos',
        name: 'enterprise.documents',
        component: page('enterprises/documents/index.vue'),
        props: true,
      },
      {
        path: 'dispositivos',
        name: 'enterprise.devices',
        component: page('enterprises/devices/index.vue'),
        props: true,
      },
      {
        path: 'certificado',
        component: page('enterprises/certificate/index.vue'),
        name: 'enterprise.certificates',
        children:
          [
            {
              path: '',
              redirect: {
                name: 'enterprise.certificates.fel',
              },
            },
            {
              path: '',
              name: 'enterprise.index',
              component: page('enterprises/certificate/index.vue'),
            },
            {
              path: 'fel/mostrar',
              name: 'enterprise.certificates.fel',
              component: page('enterprises/certificate/viewFEL.vue'),
              props: true,
            },
            {
              path: 'fel/importar',
              name: 'enterprise.certificates.fel.upload',
              component: page('enterprises/certificate/uploadFEL.vue'),
              props: true,
            },
            {
              path: 'pac/mostrar',
              name: 'enterprise.certificates.pac',
              component: page('enterprises/certificate/viewPAC.vue'),
              props: true,
            },
            {
              path: 'pac/importar',
              name: 'enterprise.certificates.pac.upload',
              component: page('enterprises/certificate/uploadPAC.vue'),
              props: true,
            },
          ],
      },
      {
        path: 'otros',
        name: 'enterprise.others',
        component: page('enterprises/others/index.vue'),
        props: true,
      },
      {
        path: 'afiliacion',
        name: 'enterprise.membership',
        component: page('enterprises/others/membership.vue'),
        props: true,
      },
    ],
  },
  {
    path: '/bitacoras',
    name: 'binnacle',
    component: page('binnacle/index.vue'),
    props: true,
  },
  {
    path: '/movimientos',
    name: 'transactions',
    component: page('transactions/index.vue'),
    props: true,
  },
  {
    path: '/notificaciones',
    name: 'notification',
    component: page('notification/index.vue'),
    props: true,
  },

  { path: '*', component: page('errors/404.vue') },
];
